<template>
  <div id="sgg-avg-amount-wrapper" class="summary-card">
    <div class="card-title">구별 평균 거래금액 랭킹</div>
    <div class="months-selector">
      <button
        v-for="m in [1, 3, 6, 12]"
        :key="m"
        :class="{ active: months === m }"
        @click="changeMonths(m)"
      >{{ m }}개월</button>
    </div>
    <div v-if="loading" class="loading-state"><p>불러오는 중...</p></div>
    <div v-else class="ranking-list">
      <div class="ranking-row ranking-header">
        <span class="rank-num">#</span>
        <span class="rank-name">구</span>
        <span class="rank-amount">평균</span>
        <span class="rank-min">최저</span>
        <span class="rank-max">최고</span>
        <span class="rank-count">건수</span>
      </div>
      <div
        v-for="(item, idx) in rankingList"
        :key="item.sggCd"
        class="ranking-row"
      >
        <span class="rank-num" :class="{ 'top3': idx < 3 }">{{ idx + 1 }}</span>
        <span class="rank-name">{{ item.sggNm }}</span>
        <span class="rank-amount">{{ toEok(item.avgAmount) }}억</span>
        <span class="rank-min">{{ toEok(item.minAmount) }}억</span>
        <span class="rank-max">{{ toEok(item.maxAmount) }}억</span>
        <span class="rank-count">{{ item.tradeCount.toLocaleString() }}건</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";

export default defineComponent({
  name: "SggAvgAmount",
  mixins: [UtilMixin],
  data() {
    return {
      months: 3,
      rankingList: [] as any[],
      loading: false,
    };
  },
  methods: {
    toEok(amount: number): string {
      return (Math.ceil(amount / 100) / 100).toFixed(2);
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await this.getApi().apt().getSggAvgAmount({ months: this.months });
        this.rankingList = res || [];
      } catch {
        this.rankingList = [];
      } finally {
        this.loading = false;
      }
    },
    changeMonths(m: number) {
      this.months = m;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
});
</script>
